$(document).ready(function () {

  /**************************************************
   * loading screen
   **************************************************/
  //$('.loading-screen').fadeOut();
  /*$(window).on('beforeunload', function() {
    $('.loading-screen').fadeIn();
  })*/

  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
  });

  initMobileMenu();

})
window.captchaCallback = function(response) {
  $(".g-recaptcha").val(response);
};

function initMobileMenu(){
  if($("#mobileMenuNav").length > 0)
  {
    var menu = new MmenuLight($("#mobileMenuNav").get(0));

    /*mmenu.create("(max-width: 1200px)");

     mmenu.init("current");*/
    var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        // title: 'Menu'
    });

    var drawer = menu.offcanvas({
        position: 'left'
    });

    $('#btnMobileMenu').on("click", function(ev) {
        $('#mobileMenuNav').css("display", "block");
        drawer.open();

        ev.preventDefault();
        ev.stopPropagation();
    });  
  }
}

// $(window).on('scroll', function() {

//     var header = $('navbar-top');
//     var sticky = $('.banner').innerHeight() - header.innerHeight();

//     stickyHeader(header, sticky);

// });

// function stickyHeader(header, sticky) {
//     if ($(window).scrollTop() > sticky) {
//         header.addClass('sticky-nav');
//     } else {
//         header.removeClass('sticky-nav');
//     }
// }

window.onscroll = function() {
  stickyNav()
};

var header = document.getElementById("navbar-top");
var sticky = header.offsetTop;

function stickyNav() {
  if (window.pageYOffset > sticky) {
      header.classList.add("sticky-nav");
      // $('.banner').innerHeight(95);
  } else {
      header.classList.remove("sticky-nav");
  }
}


//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e) {
  imgToBG($(".bg-img"), ".img-bg");
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
      e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

function imgToBG(bgClass, imageClass) {
  if (bgClass.length > 0) {
      bgClass.each(function() {
          var img = $(this).find(imageClass).eq(0);
          $(this).attr('data-bg', img.attr("src"));
          img.hide();
      });
  }
}
